const autoNgTemplateLoaderTemplate1 = require('./registry-form-azure.html');

angular.module('shbdeployer.app').component('registryFormAzure', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    model: '=',
    formAction: '<',
    formActionLabel: '@',
    actionInProgress: '<',
  },
});
